import lightGallery from 'lightgallery';

// Plugins
//import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
//import lgVideo from 'lightgallery/plugins/video'


export const LightGallery = (root = document) => {

    // group images by component; skip already-initialized galleries
    const galleryContainer = [...root.querySelectorAll("[data-lightbox-gallery]:not([data-lightbox-initialized])")]
    if (galleryContainer.length) {
        galleryContainer.forEach(container => {
            container.dataset.lightboxInitialized = 'true'
            lightGallery(container, {
                speed: 500,
                controls: true,
                download: false,
                counter: false,
                nextHtml: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" width="7" height="12" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.857 6.416.285 10.984l.931.932 5.5-5.5-5.5-5.5-.93.931 4.571 4.569Z" fill="currentColor"/></svg>',
                prevHtml: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" width="7" height="12" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="m2.143 6.416 4.572 4.568-.931.932-5.5-5.5 5.5-5.5.93.931-4.571 4.569Z" fill="currentColor"/></svg>',
                defaultCaptionHeight: 100,
                getCaptionFromTitleOrAlt: true,
                licenseKey: '69080706-1AC0-46D4-92AC-34A021105012',
                zoom: false,
                mobileSettings: {
                    showCloseIcon: true
                },
                selector: '[data-lightbox]',
                plugins: [lgZoom]
            });

        });
    }



}